export default "__VITE_ASSET__ad8b53f9__"